// src/com/tsr/TsrPrintAdc.js
import React, {useEffect} from 'react';
import TopHomeplusPng from '../../asset/image/top_homeplus.png';
import {
    tsrDateTime, tsrLetter, tsrNumber, TsrPageStyle, TsrStyles
} from './TsrStyle';

// "border-bottom: 1px solid; width:31mm"
const StyleSignUnderline = {borderBottom: '1px solid', width: '31mm'};
/**
 * 상온 물류센터용 TSR 출력
 * TsrMain에서 tsrData를 받아 출력한다.
 * @param {*} param0 
 */
export default function TsrPrintAdc({tsrData}) {
    const printedRef = React.useRef(false);

    useEffect(() => {
        //document.body.style = import('../../asset/css/NT_TrailerSeal.css');
        document.title = "(ADC)TSR 장표발행";
    }, []);

    useEffect(()=>{
        if(tsrData.storeId && !printedRef.current) {
            window.print();
            printedRef.current = true;
        }
    }, [tsrData]);
    
    const renderSeal = (sealNo) => {
        return (
            <ol className="seal_box">
                {
                    Array.from({length: 5}, (v, k) => k).map((idx) => {
                        return <li key={idx}>{tsrLetter(sealNo,idx)}</li>
                    })
                }
            </ol>
        );
    };

    return (
        <div size="A4" style={TsrPageStyle}>
            {/* <!-- 타이틀 --> */}
            <div className="tsr_title" style={{verticalAlign: 'bottom'}}>
                <div style={{width: '50mm'}}><img alt="홈플러스 로고" src={TopHomeplusPng} style={{width:'100px'}}/></div>
                <div className="text_trailer" style={{width:'100mm', textAlign:'center'}}>TRAILER SEAL RECORD</div>
                <div className="border_box" style={{width:'55mm', height:'4mm'}}>배차구분 : {tsrData.transType}</div>
            </div>
            {/* <!-- 헤더 (출발지) --> */}
            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                <div className="black_box" style={{
                    width: '50mm', height: '4mm', display: 'inline-table', fontSize: '16px', verticalAlign: 'middle'
                }}>출발지: {tsrData.dcName}</div>
                <div style={{width:"23mm"}}></div>
                <div className="border_box" style={TsrStyles.div60x4}>차종 : {tsrData.vehTypeName}</div>
                <div className="border_box" style={TsrStyles.div65x4}>상차완료 : {tsrDateTime(tsrData.loadEnTime)}</div>
            </div>
            {/* <!-- 헤더 (도착지) "width:20mm;height:12mm;display:inline-table;"  --> */}
            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                <div className="black_box" style={{ width: '50mm', height: '12mm', display: 'inline-table' }}><div className="arrive_text">{tsrData.storeName}</div></div>
                <div className="black_box" style={{ width: '20mm', height: '12mm', display: 'inline-table' }}><div className="arrive_text">{tsrData.hocha} 호</div></div>
                <div className="border_box" style={TsrStyles.div60x4}>차량번호 : {tsrData.vehPlates}</div>
                <div className="border_box" style={TsrStyles.div65x4}>출발예정 : {tsrDateTime(tsrData.prosDptrTime)}</div>
                <div className="border_box" style={TsrStyles.div60x4}>운행기사 : {tsrData.driverName}</div>
                <div className="black_box" style={TsrStyles.div65x4}>도착예정 : {tsrDateTime(tsrData.prosArrTime)}</div>
            </div>
            {/* <!-- 주소 / 전화번호   --> */}
            <div className="tsr_box">
                도착지 주소 : {tsrData.storeAddr}
            </div>
            <div style={{fontSize: '13px'}}>
                전화번호 : {tsrData.storeOfficeTelno}
            </div>

            {/* <!-- 봉인번호 --> */}
            <div className="tsr_box tsr_sub_t">
                <div className="tsr_sub_t_text">■ 봉인번호(Seal Number)</div>
                <div className="tsr_sub_t_box">
                    {tsrData.bindStores ? tsrData.bindStores.map((store) => store.storeName).join(">>"):null}
                </div>
                <div style={{width: '145mm', marginTop: '1mm'}}>
                    {renderSeal(tsrData.sealNo1)}
                    {renderSeal(tsrData.sealNo2)}
                    {renderSeal(tsrData.sealNo3)}
                    <div className="dot_box"><span>봉인부착</span></div>
                    <div className="dot_box"><span>봉인부착</span></div>
                    <div className="dot_box"><span>봉인부착</span></div>
                </div>
                {/* <!-- 점포명 / 봉인번호 확인 서명 --> */}
                <div style={{width: '60mm'}}>
                    <div className="tsr_sub_t_text">■ 점포명/봉인번호 확인 서명</div>
                    <div className="border_box" style={{height:'19mm'}}><br/>
                        운행기사 : <div style={StyleSignUnderline}></div>&nbsp;(서명)<br/><br/><br/>
                        점포담당 : <div style={StyleSignUnderline}></div>&nbsp;(서명)
                    </div>
                </div>
                <div style={{textAlign: 'center', marginTop: '2mm'}}>
                    ※ 봉인 개봉 전 점포명과 봉인번호를 다시 한번 확인하시기 바라며 이상 없을 시 서명하여 주시기 바랍니다.
                </div>
            </div>
            <div className="tsr_box" style={TsrStyles.noTopMargin}>
                {/* <!-- 물류집기 출고 현황 --> */}
                <div className="tsr_sub_t_text">■ 물류집기 출고 현황</div><br/>
                
                    <table width="100%" height="100px" className="out_table2" style={TsrStyles.topMargin2mm}>
                        <tbody>
                        <tr>
                            <td colSpan="4">Pallet</td>
                            <td colSpan="2">Rollcage</td>
                            <td colSpan="3">Other Pallet</td>
                            <td colSpan="2">고가상품</td>
                            <td rowSpan="2">Tray</td>
                        </tr>
                        <tr>
                            <td>합계</td>
                            <td>KPP<label className="mini_text">(적색)</label></td>
                            <td>AJU<label className="mini_text">(연두색)</label></td>
                            <td>기타</td>
                            <td>일반</td>
                            <td>점간대출</td>
                            <td>특정</td>
                            <td>점간대출</td>
                            <td>Trunking</td>
                            <td>단프라</td>
                            <td>롤케이지</td>
                        </tr>
                        <tr>
                            <td className="t_td_cell">{
                                tsrNumber(
                                    tsrData.aPalKpp
                                    + tsrData.aPalAju
                                    + tsrData.aRollN
                                    + tsrData.aRollJum
                                    + tsrData.aB2bKpp // 아래에는 안나타남
                                    + tsrData.aB2bAju // 아래에는 안나타남
                                    + tsrData.aEtc
                                    + tsrData.aTray
                                    + tsrData.aOpSpec
                                    + tsrData.aOpJum
                                    + tsrData.aOpTrunc
                                    + tsrData.aHiDanpra
                                    + tsrData.aHiRoll
                                )
                                }</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aPalKpp)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aPalAju)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aEtc)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aRollN)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aRollJum)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aOpSpec)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aOpJum)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aOpTrunc)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aHiDanpra)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aHiRoll)}</td>
                            <td className="t_td_cell">{tsrNumber(tsrData.aTray)}</td>
                        </tr>
                        </tbody>
                    </table>
                
            </div>

            <div className="tsr_box">
                {/* <!-- 비고, 특이사항  */}
                <div style={{width: '145mm'}}>
                    <div className="tsr_sub_t_text" style={{ width: '25mm', height: '4mm', float: 'left' }}>■ 비고</div>
                    <div className="border_box" style={{ width: '112mm', height: '4mm' }}>{tsrData.note}</div>
                    <div className="tsr_sub_t_text" style={{ width: '25mm', height: '10mm', float: 'left' }}>■ 특이사항</div>
                    <div className="border_box" style={{ width: '112mm', height: '30mm' }}>{tsrData.memo}</div>
                </div>
                {/* <!-- 상차정보  "width:20mm;text-align: right;" -->  */}
                <div style={{width: '60mm', marginTop: '1mm'}}>
                    <div className="tsr_sub_t_text" style={{marginBottom:'1mm'}}>■ 상차정보</div>
                    ．상차수량 : <div className="underbar_line" style={{width: '20mm', textAlign: 'right'}}>{tsrData.loadCount}</div>&nbsp;Case<br/>
                    ．BOL Number<br/>
                    <div className="border_box" style={TsrStyles.div60x4}>{tsrData.bol1}</div>
                    <div className="border_box" style={TsrStyles.div60x4}>{tsrData.bol2}</div>
                    <div className="border_box" style={TsrStyles.div60x4}>{tsrData.bol3}</div>
                </div>
                {/* <!-- 전일 미출고--> 
                <!-- 
                <div style="width:60mm; margin-top:2mm;">
                    ．전일 미출고 BOL Number<br/>
                    <div className="border_box" style="width:60mm;height:4mm;margin-top:2mm;"> </div>
                    <div style="margin-top:2mm;">．전일 미출고 <div className="underbar_line" style="width:8mm;text-align: right;">0</div> Pallert<div className="underbar_line" style="width:8mm;text-align: right;">0</div> Case</div>
                </div>
                --> */}
            </div>

            {/* <!-- transport Manager / Operation Manager / 상차작업자 --> */}
            <div className="tsr_box">
                <div className="tsr_sub_t_text" style={{width:'43mm'}}>■ Transport Manager:</div>
                <div className="underbar_line" style={TsrStyles.width25mm}>{tsrData.dcTransStaffName}</div>
                <div className="tsr_sub_t_text" style={{width:'44mm'}}>■ Operation Manager:</div>
                <div className="underbar_line" style={TsrStyles.width25mm}>{tsrData.dcOperStaffName}</div>
                <div className="tsr_sub_t_text" style={{width:'30mm'}}>■ 상차 작업자:</div>
                <div className="underbar_line" style={TsrStyles.width25mm}>{tsrData.loadStaffName}</div> (서명)
            </div>
            {/* <!-- 도착지 수기 입력   --> */}
            <div className="tsr_box border_box" style={{ width: '205mm', marginTop: '3mm', }}>
                {/* <!-- 도착지 명 "width:60mm;font-size:19px;vertical-align: middle;padding:3mm;font-weight:bold;"--> */}
                <div style={{ width: '143mm', marginTop: '0mm' }}>
                    <div className="black_box" style={{
                        width: '60mm', fontSize: '19px', verticalAlign: 'middle', padding: '3mm', fontWeight: 'bold'
                    }}>도착지: {tsrData.storeName}</div>
                    {/* <!-- 운송차량 시간관리 / 물류집기 반납현황 / 점포, 품목 수량 --> */}
                    <table className="arrive_table" style={TsrStyles.topMargin2mm}>
                        <tbody>
                        <tr>
                            <td colSpan="2">운송차량 시간관리</td>
                            <td colSpan="5">물류집기 반납현황</td>
                        </tr>
                        <tr>
                            <td style={{width:'23mm'}}>점포도착시간</td>
                            <td style={{width:'23mm'}}>점포출발시간</td>
                            <td>KPP<br/><label className="mini_text">(적색)</label></td>
                            <td>AJU<br/><label className="mini_text">(연두색)</label></td>
                            <td>Rollcage</td>
                            <td>기타</td>
                            <td>Tray</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
                    
                    {/* <!-- 점포명, 품목, 수량 --> */}
                    <table className="store_table" style={TsrStyles.topMargin2mm}>
                        <tbody>
                        <tr><td style={{width:'25mm'}}>대입 점포명</td>
                            <td style={{width:'85mm'}}>품목(점간 대출입)</td>
                            <td style={{width:'25mm'}}>수량</td>
                        </tr>
                        <tr><td rowSpan="3"></td><td></td><td rowSpan="3"></td></tr>
                        <tr><td></td></tr>
                        <tr><td></td></tr>
                        </tbody>
                    </table>
                    
                            
                    {/* <!-- 정보 --> */}
                    <div className="tsr_info" style={TsrStyles.topMargin2mm}>
                        <label>1.점포에서 물류센터로 배송되는 상품/반품은 반드시 새로운 봉인번호를 기입하시기 바랍니다.</label><br/>
                        <label>2.점포 담당자께서는 물류집기 및 반품 상차 시 운송기사의 확인 서명을 받으시기 바랍니다.</label><br/>
                        <label>3.본 차량에 적재한 반품 명세서를 발행하여 첨부하여 주시기 바랍니다.</label>
                    </div>
                </div>
                
                {/* <!-- 출발 봉인번호 "width:60mm; margin-top:2mm;"--> */}
                <div style={{ width: '60mm', marginTop: '2mm' }}>
                    <div className="tsr_sub_t_text">■ 출발 봉인번호</div>
                    <ol className="seal_box" style={TsrStyles.topMargin2mm}><li></li><li></li><li></li><li></li><li></li></ol>
                    <div className="dot_box"><span>봉인부착</span></div>
                </div>
                
                {/* <!-- 특이사항  --> */}
                <div style={{ width: '60mm', marginTop: '2mm' }}>
                    <div className="tsr_sub_t_text">■ 특이사항</div>
                    <div className="underbar_line" style={{textAlign:'right', height:'4mm'}}></div>
                    <div className="underbar_line" style={{textAlign:'right', height:'4mm'}}></div>
                    <div className="underbar_line" style={{textAlign:'right', height:'4mm'}}></div>
                </div>
                    
                {/* <!-- 운행기사/ 점포담당자 사인 "width:33mm;height:4mm;" --> */}
                <div style={{ width: '60mm', marginTop: '4mm' }}>
                    운행기사 : <div className="underbar_line" style={{ width: '33mm', height: '4mm' }}></div>(서명)<br/><br/>
                    점포담당 : <div className="underbar_line" style={{ width: '33mm', height: '4mm' }}></div>(서명)
                </div>
            </div>

            {/* <!--  "text-align: left;margin-top: 2mm;margin-left:6mm;"   --> */}
            <div style={{ textAlign: 'left', marginTop: '2mm', marginLeft: '6mm' }}>
                ※  운송기사는 운송 중 적재물의 분실, 파손, 화재 안전사고 발생 및 도착지연 예상 시 지체 없이 통합운송센터/운송사로 연락해야 합니다. 
            </div>
            <div>
                <div className="tsr_sub_t_text" style={TsrStyles.width65mm}>■ 운송사 : {tsrData.comName}</div>
                <div className="tsr_sub_t_text" style={TsrStyles.width60mm}>소장 : {tsrData.comAgentName} {tsrData.comOfficeTel}</div>
                <div className="tsr_sub_t_text" style={TsrStyles.width80mm}>■ 통합운송센터 : {tsrData.dcStaffName} {tsrData.dcOfficeTelno}</div>
                <div className="tsr_sub_t_text" style={TsrStyles.width60mm}>■ 도착지 : {tsrData.storeName}</div>
                <div className="tsr_sub_t_text" style={TsrStyles.width60mm}>사무실 : {tsrData.storeStaffName} {tsrData.storeOfficeTelno}</div>
                <div className="tsr_sub_t_text" style={TsrStyles.width60mm}>보안실 : {tsrData.storeSecuTelno}</div>
            </div>
        </div>
    );
}
